import React from 'react';
import styled from 'styled-components';
import { variables } from '../../../styles/variables';

interface Props {
  visible: boolean;
}

const LanguageSwitcherStyleWrapper: React.FunctionComponent<Props> = styled('ul') <Props>`
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  list-style: none;
  width: 100%;
  font-weight: 300;
  font-size: 2rem;
  padding: 20px 5px; 
  border-top: 1px solid #788195; 
  margin-top: 20px;
  li {
    color: ${variables.colorMainText};
    cursor: pointer;
    &.active {
      font-weight: 700;
    }
  }
  @media (max-width: 786px), (max-height: 567px) {
    padding: 7px 0px; 
    margin-top: 7px;
  }
`;

export default LanguageSwitcherStyleWrapper;
